import React from "react"
import Logo from "./images/logo.png"

function Header() {
  return (
    <nav className="navbar navbar-light" style={{ backgroundColor: "#e3f2fd" }}>
      <label className="navbar-brand">
        <img src={Logo} width="10" height="30" className="d-inline-block align-top header-logo" alt=""/>
          The Creative Finance
      </label>
      <form className="form-inline">
        <label className="btn btn-outline-primary my-2 my-sm-0" type="submit">Login</label>
      </form>
    </nav>
  )
}

export default Header
